export const educationData = [
  {
    id: 1,
    degree: "DBA - Doctor of Business Administration",
    field: "Artificial Intelligence & Cybersecurity",
    institution: "Integrated Management Educational Technology",
    year: "2025",
    current: false
  },
  {
    id: 2,
    degree: "Master of Business Administration (MBA)",
    field: "Human Resources Management",
    institution: "The ICFAI University, Dehradun",
    year: "Completed",
    current: false
  },
  {
    id: 3,
    degree: "M.Com",
    field: "Marketing",
    institution: "University of Pune",
    year: "Completed",
    current: false
  }
];

export const certificationsData = [
  "Diversity Recruiting",
  "Critical Thinking for Better Judgment and Decision-Making",
  "Building AI Products: Security Essentials - Professional Certificate",
  "Developing Managers in Organizations",
  "Ram Charan on Coaching High Potentials"
];
